import type { ConnectorPhaseRotations, Phase } from '../redux/api/web-api'

export enum Phases {
    L1 = 'L1',
    L2 = 'L2',
    L3 = 'L3',
    L123 = 'L123',
    L1L2 = 'L1L2',
    L2L3 = 'L2L3',
    L3L1 = 'L3L1',
    L1L2L3 = 'L1,L2,L3',
}

export enum PhaseMode {
    onePhase = '1P',
    twoPhase = '2P',
    threePhase = '3P',
}

export const CHARGEPOINT_MIN_CURRENT = 6

export const capiPhaseModeOptions = ['1P', '3P'].map((x) => ({ value: x, label: x }))
const singlePhases = ['L1', 'L2', 'L3']
export const singlePhaseOptions = singlePhases.map((value) => ({ value, label: value }))
export const loadBalancerItPhaseOptions = [{ value: 'L1,L2,L3', label: 'L1,L2,L3' }]

export const PHASES_LIST_TN = [...singlePhases, 'L123']
export const PHASES_LIST_IT = ['L1L2', 'L2L3', 'L3L1']
export const LUNA_PHASES_LIST = ['L1', 'L123']
export const LUNA_PHASES_LIST_IT = ['L1L2']
export const installationPhasesOptionsTN = ['1', '3'].map((x) => ({ value: x, label: x }))
export const installationPhasesOptionsIT = ['2', '3'].map((x) => ({ value: x, label: x }))
export const installationPhasesOrderOptions = ['RST', 'RTS', 'SRT', 'STR', 'TRS', 'TSR'].map((x) => ({
    value: x,
    label: x,
}))

const phaseIndices: Record<Phase, number[]> = {
    L1: [0],
    L2: [1],
    L3: [2],
    L123: [0, 1, 2],
    L1L2: [0, 1],
    L2L3: [1, 2],
    L3L1: [2, 0],
}
const supplyPhases: Record<string, Phase> = {
    R: 'L1',
    S: 'L2',
    T: 'L3',
    RS: 'L1L2',
    ST: 'L2L3',
    RT: 'L3L1',
    RST: 'L123',
}

export const getSupplyPhase = (
    phase: Phase | null | undefined,
    rotation: ConnectorPhaseRotations | null | undefined
): Phase | undefined => {
    if (!phase) return undefined
    if (phase === 'L123') return phase
    if (!rotation) return undefined
    return supplyPhases[
        phaseIndices[phase]
            .map((index) => rotation[index])
            .sort()
            .join('')
    ]
}

export const getInstallationCurrentLimit = (supplyCurrent: number, factoryCurrent?: number | null): number =>
    Math.min(supplyCurrent, factoryCurrent ?? supplyCurrent)
